import styled from 'styled-components';

export const InformationList = styled.ul`
  padding: 0px 16px;

  hr {
    border-top: 1px solid #49475B ;
    opacity: 0.3;
    padding: 0;
    margin: 12px 0;
  }

  li {
    font-weight: 400;
    font-size: 10px;
    line-height: 1.6;
    color: #49475B;

    span {
      font-weight: bold;
    }
  }
`